export default __webpack_public_path__ + "static/media/356.e458763c.gif";